import { Button, Container, MultipleAccordion } from '@/DesignSystem/Component';
import { LINKS } from '@/Module/Core/Constant';
import HomePageQuestionRight from '@/Module/HomePage/Component/HomePageContainer/HomePageQuestionRight';
import { useSubscriptionFAQ } from '@/Module/Subscription/Hooks';
const SubscriptionQuestion = () => {
  const {
    preparedData,
    isLoading
  } = useSubscriptionFAQ();
  return <Container className=" min-w-full   overflow-hidden   border-[7px] border-blueFive bg-orangeThree bg-question-homePage-bg bg-center bg-no-repeat p-5   " data-sentry-element="Container" data-sentry-component="SubscriptionQuestion" data-sentry-source-file="SubscriptionQuestion.tsx">
      <div className="flex min-w-full flex-col  items-center justify-center lg:flex-row lg:items-end ">
        <HomePageQuestionRight data-sentry-element="HomePageQuestionRight" data-sentry-source-file="SubscriptionQuestion.tsx" />
        <div className=" flex w-full flex-col  lg:mr-20 lg:max-w-[850px] ">
          {preparedData.length ? <>
              <MultipleAccordion className=" mb-3 mt-8 flex w-full flex-col gap-4 " items={preparedData} />
              <Button as="a" href={LINKS.QUESTION} variant="shadow" color="primaryOrange" radius="circle" type="submit" isLoading={isLoading} className=" mb-8 mt-6 w-full p-5 lg:mb-32 ">
                سؤال شما اینجا نبود؟
              </Button>
            </> : <div className="m-7 w-full max-w-[850px] bg-white p-5 text-center text-lg font-bold text-orangeFive">
              پرسشی تحت گروهبندی انتخاب شده وجود ندارد!
            </div>}
        </div>
      </div>
    </Container>;
};
export default SubscriptionQuestion;